export const getId = param => {
  const result = param.split('-');
  return result[result.length - 1];
};

export function getUrlExtension(url) {
  return url.split(/[#?]/)[0].split('.').pop().trim();
}

export function prepSearch(str) {
 return nonAccentVietnamese(str.trim()).toLowerCase();
}

export function nonAccentVietnamese(str) {
  let result = str;
  result = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  result = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  result = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  result = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  result = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  result = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  result = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  result = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  result = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  result = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  result = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  result = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  result = str.replace(/đ/g, 'd');
  result = str.replace(/Đ/g, 'D');
  result = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '');
  result = str.replace(/\u02C6|\u0306|\u031B/g, '');
  return result;
}



// WEBPACK FOOTER //
// ./src/utils/params.js